import { render, staticRenderFns } from "./UserBanner.vue?vue&type=template&id=0dbb5066&"
import script from "./UserBanner.vue?vue&type=script&lang=js&"
export * from "./UserBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports